import { styled, Tooltip } from "@monolith-forensics/monolith-ui";
import { HelpCircleIcon } from "lucide-react";
import { ManagedTooltip } from "./ManagedRowIcon";

const StyledHint = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: 50%;
  cursor: help;
  // The disabled menu item turns pointer events off; the hint needs them.
  pointer-events: auto;
  color: ${({ theme }) => theme.palette.text.secondary};

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

/**
 * The (?) beside a grayed out action on a managed folder (ENG-2133). A
 * disabled menu item can't be hovered itself, so its reason hangs off this.
 */
export const ManagedActionHint: React.FC<{
  // Why the action is off, e.g. managedFolderMessage("deleted").
  message: string;
  "data-testid"?: string;
}> = ({ message, "data-testid": testId }) => (
  <Tooltip
    content={<ManagedTooltip>{message}</ManagedTooltip>}
    side="right"
    hoverableContent
    delayDuration={0}
  >
    <StyledHint role="img" aria-label={message} data-testid={testId}>
      <HelpCircleIcon size={12} />
    </StyledHint>
  </Tooltip>
);
